"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _excluded = ["children", "classes", "setActionBarContainerNode"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      position: 'relative',
      height: '100%',
      minWidth: 0,
      flexGrow: 1
    }
  };
});

var MainView = function MainView(_ref) {
  var children = _ref.children,
      eClasses = _ref.classes,
      setActionBarContainerNode = _ref.setActionBarContainerNode,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    classes: eClasses
  });
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: classes.root,
    ref: setActionBarContainerNode
  }, other), children);
};

MainView.propTypes = {
  children: _propTypes["default"].node.isRequired,
  setActionBarContainerNode: _propTypes["default"].func.isRequired
};
var _default = MainView;
exports["default"] = _default;